//@ts-check
import * as Sentry from "@sentry/browser";

const SENTRY_RELEASE_NAME = process.env.SENTRY_RELEASE_NAME
const SENTRY_ENVIRONMENT = process.env.ENVIRONMENT_TYPE;

function enable() {
    if (window?.location?.hostname === "localhost" || window?.location?.hostname === "127.0.0.1") {
        return false;
    }
    if (!new URLSearchParams(window?.location?.search).size) {
        return false;
    }
    return true
}

export function initSentry() {
    Sentry.init({
        release: "games@" + (SENTRY_RELEASE_NAME || "development"),
        enabled: enable(),
        dsn: "https://4205131191d198d5aed6b404630e4ede@o520731.ingest.us.sentry.io/4508993108705280",
        initialScope: {
            level: "fatal"
        },
        environment: SENTRY_ENVIRONMENT,
        beforeSend: (event, hint) => {
            if (event.message) {
                event.fingerprint = [event.message.split(" ").join("-")]
            }
            return event
        }
    });
    setTags();
}
/**
 * 
 * @param {string} msg 
 * @param {number} sampleRate 
 */
export function captureSampleError(msg, sampleRate) {
    if (Math.random() < sampleRate) {
        Sentry.captureMessage(msg, { level: "info" })
    }
}

function setTags() {
    const url = new URL(document.location.href);
    const params = url.searchParams;
    //default value, it should never happen unless something that is essential is missing from URL
    const EMPTY_ERROR = "empty_error"
    Sentry.setTags({
        stage: params.get("stage") || EMPTY_ERROR,
        gameserver: params.get("gameServerAddress") || EMPTY_ERROR,
        gameId: params.get("gameId") || EMPTY_ERROR,
        oldWebJackpots: !!params.get("gameUrl")
    })
}
